<template>
  <aside
    v-on-clickaway="hideMe"
    class="aside-menu">
    <slot>Aside</slot>
  </aside>
</template>

<script>
import { mixin as clickaway } from "vue-clickaway";

export default {
  mixins: [clickaway],
  props: {
    fixed: {
      type: Boolean,
      default: true
    },
    display: {
      type: String,
      default: ""
    },
    offCanvas: {
      type: Boolean,
      default: true
    }
  },
  mounted: function() {
    this.isFixed(this.fixed);
    this.isOffCanvas(this.offCanvas);
    // document.addEventListener('click', this.handleClick);
  },
  methods: {
    hideMe() {
      if (document.body.classList.contains("aside-menu-lg-show")) {
        document.body.classList.toggle("aside-menu-lg-show");
      }
    },
    isFixed(fixed) {
      fixed ? document.body.classList.add("aside-menu-fixed") : document.body.classList.remove("aside-menu-fixed");
      return fixed;
    },
    isOffCanvas(offCanvas) {
      offCanvas ? document.body.classList.add("aside-menu-off-canvas") : document.body.classList.remove("aside-menu-off-canvas");
    }
  }
};
</script>
